import React, { useCallback, useContext, useEffect, useState } from "react";
import { INIT_FILTER_STATE } from "../../../constants/driveglobalfilterinitalstates";
// import { INIT_FILTER_STATE_DRIVE_ACE } from "../../../constants/driveglobalfilterinitalstates";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates";
import useHttp from "../../../hook/use-http";
import Filter from "./Filter";
import Topkpis from "./Topkpis";
import PageSecond from "./PageSecond";
import TwoChartTemplate from "./TwoChartTemplate";
import SingleSoc from "./SingleSoc";
import SinglePie from "./SinglePie";
import DischargeDuration from "./DischargeDuration";
import RpmVsThrottle from "./RpmVsThrottle";
import RegenPercent from "./RegenPercent";
import IdlePercent from "./IdlePercent";
import BcsActiveTime from "./BcsActiveTime";
import DashboardMain from "../DashboardMain/DashboardMain";
import "./Driveanalysis.css";
import WaterMark from "../DashboardMain/WaterMark";
import AppContext from "../../../store/AppContext";

import { useSelector } from "react-redux";
import { selectLoggedInUser } from "../../../redux/userSlice";
import TableSection from "./TableSection";
import NetEnergyErc from "./NetEnergyErc";
import RangeErc from "./RangeErc";
import SingleSocErc from "./SingleSocErc";
import PageSecondErc from "./SecondPageErc/PageSecondErc";

function Driveanalysis() {
  const [gloablfilter, setGloablfilter] = useState(INIT_FILTER_STATE);
  // const [gloablfilter, setGloablfilter] = useState(INIT_FILTER_STATE_DRIVE_ACE);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const app_ctx = useContext(AppContext);

  const log_data = (data) => {};

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "auth/logging",
        body: {
          page_name: "driveanalysis",
        },
      },
      log_data
    );
  }, []);

  const filterSubmited = useCallback((data) => {
    setGloablfilter(data);
  }, []);

  const singleVinSelected = (vin) => {
    let vin_num = vin.split(",");
    setGloablfilter((prevdata) => {
      return { ...prevdata, VIN_NUM: vin_num, pageSelected: 2 };
    });
  };

  const pageChange = () => {
    setGloablfilter((prevdata) => {
      return { ...prevdata, pageSelected: 1, VIN_NUM: [] };
    });
  };

  const onreset = (data) => {
    setGloablfilter(data);
  };

  const loggedInUser = useSelector(selectLoggedInUser);
  if (gloablfilter.pageSelected === 1) {
    return (
      <>
        <DashboardMain>
          <div
            className={
              loggedInUser.flagForHideShow === "ERC"
                ? "new_drive_dashboard"
                : "drive_dashboard"
            }
          >
            <Filter
              onsubmit={filterSubmited}
              gloablfilter={gloablfilter}
              onreset={onreset}
            />
            <div className="container-fluid">
              <Topkpis gloablfilter={gloablfilter} />
              {loggedInUser.flagForHideShow === "ERC" && (
                <TableSection
                  singleVinSelected={singleVinSelected}
                  gloablfilter={gloablfilter}
                />
              )}
              <section className="graphs">
                <div className="row">
                  {/* {loggedInUser.flagForHideShow === "ERC" && (
                    <div className="col-md-12 col-sm-12 col-lg-3 mb-3">
                      <div id="wrapper" className="toggled">
                        <div id="page-content-wrapper">
                          <TopFiveSection
                            singleVinSelected={singleVinSelected}
                            gloablfilter={gloablfilter}
                          ></TopFiveSection>
                        </div>
                      </div>
                    </div>
                  )} */}
                  <div
                    className={
                      "col-md-12 col-sm-12 " +
                      (loggedInUser.flagForHideShow === "ERC"
                        ? "col-lg-12"
                        : "col-lg-12")
                    }
                  >
                    <div className="row mb-3">
                      {loggedInUser.flagForHideShow !== "ERC" && (
                        <>
                          <div className="col-md-12 col-sm-12 col-lg-6">
                            <TwoChartTemplate
                              title="Real World Range Distribution"
                              type="RANGE"
                              gloablfilter={gloablfilter}
                            ></TwoChartTemplate>
                          </div>
                          <div className="col-md-12 col-sm-12 col-lg-6">
                            <TwoChartTemplate
                              title="Net Energy consumption"
                              type="ENERGY"
                              gloablfilter={gloablfilter}
                            ></TwoChartTemplate>
                          </div>
                        </>
                      )}

                      {loggedInUser.flagForHideShow === "ERC" && (
                        <>
                          <div className="col-md-6 col-sm-12 col-lg-3 drive_graph pr-1">
                            <WaterMark />
                            <RangeErc
                              title="Real World Range Distribution"
                              gloablfilter={gloablfilter}
                              apiend="rangebarchart_erc"
                            ></RangeErc>
                          </div>
                          <div className="col-md-6 col-sm-12 col-lg-3 drive_graph pr-1">
                            <WaterMark />
                            <NetEnergyErc
                              title="Net Energy Consumption"
                              gloablfilter={gloablfilter}
                              apiend="energybarchart_erc"
                            ></NetEnergyErc>
                          </div>
                          <div className="col-md-6 col-sm-12 col-lg-3 drive_graph pr-1">
                            <WaterMark />
                            <SingleSocErc
                              title="SoC Discharge/Cycle Analysis"
                              gloablfilter={gloablfilter}
                              apiend="socbar_erc"
                            ></SingleSocErc>
                          </div>
                          <div className="col-md-6 col-sm-12 col-lg-3 drive_graph">
                            <WaterMark />
                            <DischargeDuration
                              title="Median Discharge Duration"
                              gloablfilter={gloablfilter}
                              apiend="discharge_bar"
                            ></DischargeDuration>
                          </div>
                        </>
                      )}
                    </div>

                    <div className="row mb-3 equal-cols">
                      {loggedInUser.flagForHideShow !== "ERC" && (
                        <>
                          <div className="col-md-6 col-sm-12 col-lg-6 drive_graph">
                            <WaterMark />
                            <SingleSoc
                              title="SoC Discharge/Cycle Analysis"
                              gloablfilter={gloablfilter}
                              apiend="socbar"
                            ></SingleSoc>
                          </div>
                          <div className="col-md-6 col-sm-12 col-lg-6">
                            <WaterMark />
                            <SinglePie
                              title="Mode utilization"
                              gloablfilter={gloablfilter}
                              apiend="piechart"
                            ></SinglePie>
                          </div>
                        </>
                      )}
                      {loggedInUser.flagForHideShow === "ERC" && (
                        <>
                          <div className="col-md-6 col-sm-12 col-lg-3 pr-1 drive_graph">
                            <WaterMark />
                            <RpmVsThrottle
                              title="Median RPM vs Median Throttle"
                              gloablfilter={gloablfilter}
                              apiend="rpm_vs_throttle_erc"
                            ></RpmVsThrottle>
                          </div>
                          <div className="col-md-6 col-sm-12 col-lg-3 pr-1 drive_graph">
                            <WaterMark />
                            <RegenPercent
                              title="Median Regen Percent"
                              gloablfilter={gloablfilter}
                              apiend="regenbar"
                            ></RegenPercent>
                          </div>
                          <div className="col-md-6 col-sm-12 col-lg-3 pr-1 drive_graph">
                            <WaterMark />
                            <IdlePercent
                              title="Median Idle Percent"
                              gloablfilter={gloablfilter}
                              apiend="idlebar"
                            ></IdlePercent>
                          </div>
                        </>
                      )}
                      {/* <div
                        className={
                          loggedInUser.flagForHideShow === "ERC"
                            ? "col-md-6 col-sm-4 col-lg-3 pr-1"
                            : "col-md-6 col-sm-6"
                        }
                      >
                        <WaterMark />
                        <SingleSoc
                          title="SoC Discharge/Cycle Analysis"
                          gloablfilter={gloablfilter}
                          apiend="socbar"
                        ></SingleSoc>
                      </div> */}
                      {/* <div
                        className={
                          loggedInUser.flagForHideShow === "ERC"
                            ? "col-md-6 col-sm-4 col-lg-3 pr-1"
                            : "col-md-6 col-sm-6"
                        }
                      >
                        <WaterMark />
                        <SinglePie
                          title="Mode utilization"
                          gloablfilter={gloablfilter}
                          apiend="piechart"
                        ></SinglePie>
                      </div> */}
                      {loggedInUser.flagForHideShow === "ERC" && (
                        <div className="col-md-6 col-sm-12 col-lg-3 drive_graph">
                          <WaterMark />
                          <BcsActiveTime
                            title="Median BCS Active Time"
                            gloablfilter={gloablfilter}
                            apiend="bcs_activebar"
                          ></BcsActiveTime>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </DashboardMain>
      </>
    );
  } else {
    return (
      <DashboardMain>
        {loggedInUser.flagForHideShow !== "ERC" ? (
          <PageSecond gloablfilter={gloablfilter} pageChange={pageChange} />
        ) : (
          <div className="new_drive_dashboard">
            <PageSecondErc
              gloablfilter={gloablfilter}
              pageChange={pageChange}
            />
          </div>
        )}
      </DashboardMain>
    );
  }
}

export default Driveanalysis;
